import { render, staticRenderFns } from "./TipoReporte.vue?vue&type=template&id=f97b76a0"
import script from "./TipoReporte.vue?vue&type=script&lang=js"
export * from "./TipoReporte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports